var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.imageString.parts),function(part){return _c('span',[(typeof part === 'string')?_c('span',[_vm._v(_vm._s(part))]):_c('img',{attrs:{"src":part.path,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }